import { useTheme, useMediaQuery } from "@mui/material";
import CustomSvgIcon from "../components/dhiramIcon"; // import your dynamic SVG component

// ---- price status util ----
function getPriceStatus(jets, status = "high") {
    if (!jets || jets.length === 0) return null;

    if (status === "high") {
        const highest = jets.reduce((max, curr) =>
            curr.price > max.price ? curr : max
        );
        return { ...highest, priceStatus: "high" };
    }

    if (status === "low") {
        const lowest = jets.reduce((min, curr) =>
            curr.price < min.price ? curr : min
        );
        return { ...lowest, priceStatus: "low" };
    }

    return null;
}

// ---- simple currency display ----
function CurrencySimple(value, color = "#000000", size = { xs: 16, sm: 16, lg: 20 }, imageType = null, imageVal = null) {
    const type = imageType ? imageType : localStorage.getItem("currencyType") || "image";
    const image = imageVal ? imageVal :
        localStorage.getItem("currencyImage") ||
        "/img/UAE_Dirham_Symbol.svg";

    return (
        <span
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
            }}
        >
            {type === "string" ? (
                <span>{String(image)}</span>
            ) : (
                <CustomSvgIcon size={size} fillColor={color} />
            )}
            {value && <span style={{ color: color }}>{value}</span>}
        </span>
    );
}

function useResponsiveValue(values) {
    const theme = useTheme();

    const matches = {
        xl: useMediaQuery(theme.breakpoints.up("xl")),
        lg: useMediaQuery(theme.breakpoints.up("lg")),
        md: useMediaQuery(theme.breakpoints.up("md")),
        sm: useMediaQuery(theme.breakpoints.up("sm")),
    };

    if (matches.xl && values.xl !== undefined) return values.xl;
    if (matches.lg && values.lg !== undefined) return values.lg;
    if (matches.md && values.md !== undefined) return values.md;
    if (matches.sm && values.sm !== undefined) return values.sm;

    return values.xs; // default
}

export { getPriceStatus, CurrencySimple, useResponsiveValue };


{/* <Box display="flex" position="relative">
<CustomSvgIcon size={50} color="red" />

<CustomSvgIcon size={200} color="#0d8196" strokeWidth={4} />

<CustomSvgIcon size="100%" color="purple" />
<CustomSvgIcon />

<CustomSvgIcon size={200} fillColor="blue" />

<CustomSvgIcon size={200} fillColor="none" strokeColor="red" strokeWidth={3} />

<CustomSvgIcon size={150} fillColor="green" strokeColor="black" strokeWidth={2} />

</Box> */}